export default {
    props: {
        value: {
            required: false
        }
    },
    data () {
        return {
            isActive: this.value
        }
    },
    watch: {
        value (val) {
            this.isActive = val
        },
        isActive (val) {
            this.$emit('input', val)
        }
    }
}
